'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 20px;\n'], ['\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 20px;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  display: block;\n  text-align: center;\n  cursor: pointer;\n'], ['\n  display: block;\n  text-align: center;\n  cursor: pointer;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  width: 100%;\n  height: 20px;\n'], ['\n  width: 100%;\n  height: 20px;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDeviceDetect = require('react-device-detect');

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Button = require('../../Button/Button');

var _Button2 = _interopRequireDefault(_Button);

var _P = require('../../P/P');

var _P2 = _interopRequireDefault(_P);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
} // Components


var Container = _styledComponents2.default.div(_templateObject);

var Content = _styledComponents2.default.a(_templateObject2);

var Space = _styledComponents2.default.div(_templateObject3);

var Download = function Download(_ref) {
  var children = _ref.children,
      file = _ref.file,
      displayOnMobile = _ref.displayOnMobile;
  return !_reactDeviceDetect.isMobile || displayOnMobile ? children : _react2.default.createElement(Container, null, _react2.default.createElement(Content, {
    href: file.document_file,
    target: '_blank'
  }, _react2.default.createElement(_Button2.default, {
    icon: 'download',
    size: 'large',
    theme: 'grey'
  }), _react2.default.createElement(Space, null), _react2.default.createElement(_P2.default, {
    inline: true
  }, file.name)));
};

Download.propTypes = {
  displayOnMobile: _propTypes2.default.bool,
  children: _propTypes2.default.node,
  file: _propTypes2.default.object
};
exports.default = Download;